import { ChartField } from 'src/app/types/chart.model'
import { TargetComparison } from 'src/app/types/enums'
import {
  JOBNUM_FIELD,
  JOBNUM_LABEL,
  NUM_MATCHED_ITEMS_VALUE_FIELD,
} from 'src/app/types/constants'
import { DashboardJobDtoBase } from 'src/app/types/dto/dashboard-job.dto'

/** DashboardJobDto with role assignments flattened on by the job lookup (see JobLookupApiService) */
export interface ProcessedDashboardJob extends DashboardJobDtoBase {
  // any number of roles [the attribute] and the person assigned to that role [value]
  [role: string]: any
}

/** job roles are added in DatasourceConfigService */
export const JOB_ALL_FIELDS: ChartField[] = [

  // string

  {
    dataField: JOBNUM_FIELD,
    displayName: JOBNUM_LABEL,
    dataType: 'string',
  },
  {
    dataField: 'contractName',
    displayName: 'Contract Name',
    dataType: 'string',
  },
  {
    dataField: 'council',
    displayName: 'Council',
    dataType: 'string',
  },
  {
    dataField: 'estate',
    displayName: 'Estate',
    dataType: 'string',
  },
  {
    dataField: 'division',
    displayName: 'Division',
    dataType: 'string',
  },
  {
    dataField: 'houseType',
    displayName: 'House Type',
    dataType: 'string',
  },
  {
    dataField: 'landZoning',
    displayName: 'Land Zoning',
    dataType: 'string',
  },
  {
    dataField: 'landTitleType',
    displayName: 'Land Title Type',
    dataType: 'string',
  },
  {
    dataField: 'landType',
    displayName: 'Land Type',
    dataType: 'string',
  },
  {
    dataField: 'jobSuburbTown',
    displayName: 'Job Suburb/Town',
    dataType: 'string',
  },
  {
    dataField: 'stage',
    displayName: 'Stage',
    dataType: 'string',
  },
  {
    dataField: 'clientSuburbTown',
    displayName: 'Client Suburb/Town',
    dataType: 'string',
  },
  {
    dataField: 'currentActivity',
    displayName: 'Current Activity',
    dataType: 'string',
  },
  {
    dataField: 'tradeRegion',
    displayName: 'Trade Region',
    dataType: 'string',
  },
  {
    dataField: 'houseArea',
    displayName: 'House Area',
    dataType: 'string',
  },
  {
    dataField: 'blockFrontage',
    displayName: 'Block Frontage',
    dataType: 'string',
  },

  // boolean

  {
    dataField: 'isActive',
    displayName: 'Is Active',
    dataType: 'boolean',
  },
  {
    dataField: 'isOnHold',
    displayName: 'Is On Hold',
    dataType: 'boolean',
  },
  {
    dataField: 'isLocked',
    displayName: 'Is Locked',
    dataType: 'boolean',
  },
  {
    dataField: 'isGSTFree',
    displayName: 'Is GST Free',
    dataType: 'boolean',
  },

  // date

  {
    dataField: 'lockedDate',
    displayName: 'Locked Date',
    dataType: 'date',
  },
  {
    dataField: 'salesDate',
    displayName: 'Sales Date',
    dataType: 'date',
  },
  {
    dataField: 'contractSignedDate',
    displayName: 'Contract Signed Date',
    dataType: 'date',
  },
  {
    dataField: 'salesQuoteSignedDate',
    displayName: 'Sales Quote Signed Date',
    dataType: 'date',
  },
  {
    dataField: 'quoteDate',
    displayName: 'Quote Date',
    dataType: 'date',
  },
  {
    dataField: 'contractQuoteDate',
    displayName: 'Contract Quote Date',
    dataType: 'date',
  },
  {
    dataField: 'titleDueDate',
    displayName: 'Title Due Date',
    dataType: 'date',
  },
  {
    dataField: 'titleCompleteDate',
    displayName: 'Title Complete Date',
    dataType: 'date',
  },
  {
    dataField: 'depositBalanceDue',
    displayName: 'Deposit Balance Due',
    dataType: 'date',
  },
  {
    dataField: 'estimatingCostingDate',
    displayName: 'Estimating Costing Date',
    dataType: 'date',
  },
  {
    dataField: 'completionDate',
    displayName: 'Completion Date',
    dataType: 'date',
  },
  {
    dataField: 'cancellationDate',
    displayName: 'Cancellation Date',
    dataType: 'date',
  },
  {
    dataField: 'handoverDate',
    displayName: 'Handover Date',
    dataType: 'date',
  },
  {
    dataField: 'targetStartDate',
    displayName: 'Target Start Date',
    dataType: 'date',
  },
  {
    dataField: 'targetCompletionDate',
    displayName: 'Target Completion Date',
    dataType: 'date',
  },
  {
    dataField: 'forecastCompletionDate',
    displayName: 'Forecast Completion Date',
    dataType: 'date',
  },
  {
    dataField: 'siteStartDate',
    displayName: 'Site Start Date',
    dataType: 'date',
  },
  {
    dataField: 'forecastSiteStartDate',
    displayName: 'Forecast Site Start Date',
    dataType: 'date',
  },
  {
    dataField: 'ordersLockedDate',
    displayName: 'Orders Locked Date',
    dataType: 'date',
  },
  {
    dataField: 'currentActivityStartDate',
    displayName: 'Current Activity Start Date',
    dataType: 'date',
  },
  {
    dataField: 'currentActivityDueDate',
    displayName: 'Current Activity Due Date',
    dataType: 'date',
  },
  {
    dataField: 'salesQuoteDueDate',
    displayName: 'Sales Quote Due Date',
    dataType: 'date',
  },
  {
    dataField: 'contractQuoteDueDate',
    displayName: 'Contract Quote Due Date',
    dataType: 'date',
  },
  {
    dataField: 'holdDate',
    displayName: 'Hold Date',
    dataType: 'date',
  },
  {
    dataField: 'maintenanceCompleteDate',
    displayName: 'Maintenance Complete Date',
    dataType: 'date',
  },
  {
    dataField: 'lastCustomerNotificationDateTime',
    displayName: 'Last Customer Notification Date',
    dataType: 'date',
  },
  {
    dataField: 'preconstructionCompleteDate',
    displayName: 'Preconstruction Complete Date',
    dataType: 'date',
  },
  {
    dataField: 'siteStartInDate',
    displayName: 'Site Start In Date',
    dataType: 'date',
  },
  {
    dataField: 'siteStartOutDate',
    displayName: 'Site Start Out Date',
    dataType: 'date',
  },
  {
    dataField: 'wipWriteOutDate',
    displayName: 'WIP Write Out Date',
    dataType: 'date',
  },

  // number

  {
    dataField: 'contractPrice',
    displayName: 'Contract Price',
    dataType: 'number',
    numberPrefix: '$',
  },
  {
    dataField: 'depositAmount',
    displayName: 'Deposit Amount',
    dataType: 'number',
    numberPrefix: '$',
  },
  {
    dataField: 'basePrice',
    displayName: 'Base Price',
    dataType: 'number',
    numberPrefix: '$',
  },
  {
    dataField: 'budgetAmount',
    displayName: 'Budget Amount',
    dataType: 'number',
    numberPrefix: '$',
  },
  {
    dataField: 'gstRate',
    displayName: 'GST Rate',
    dataType: 'number',
    numberSuffix: '%',
  },
  {
    dataField: 'depositPaid',
    displayName: 'Deposit Paid',
    dataType: 'number',
    numberPrefix: '$',
  },
  {
    dataField: 'salesQuotePrice',
    displayName: 'Sales Quote Price',
    dataType: 'number',
    numberPrefix: '$',
  },
  {
    dataField: 'estimatingTotalCost',
    displayName: 'Estimating Total Cost',
    dataType: 'number',
    numberPrefix: '$',
  },
  {
    dataField: 'salesJobCostExGst',
    displayName: 'Sales Job Cost Ex GST',
    dataType: 'number',
    numberPrefix: '$',
  },
  {
    dataField: 'contractJobCostExGst',
    displayName: 'Contract Job Cost Ex GST',
    dataType: 'number',
    numberPrefix: '$',
  },

  {
    dataField: 'postContractVariations',
    displayName: 'Post Contract Variations',
    dataType: 'number',
    numberPrefix: '$',
  },
  {
    dataField: 'contractTotalExcGST',
    displayName: 'Contract Total Exc GST',
    dataType: 'number',
    numberPrefix: '$',
  },
  {
    dataField: 'jobCostExcGST',
    displayName: 'Job Cost Exc GST',
    dataType: 'number',
    numberPrefix: '$',
    defaultTargetComparison: TargetComparison.AtMost,
  },
  {
    dataField: 'orderExtraTotal',
    displayName: 'Order Extra Total',
    dataType: 'number',
    numberPrefix: '$',
  },
  {
    dataField: 'extraIncomeIncGST',
    displayName: 'Extra Income Inc GST',
    dataType: 'number',
    numberPrefix: '$',
  },
  {
    dataField: 'markUpPercent',
    displayName: 'Mark Up Percent',
    dataType: 'number',
    numberSuffix: '%',
  },
  {
    dataField: 'marginPercent',
    displayName: 'Margin Percent',
    dataType: 'number',
    numberSuffix: '%',
  },
  {
    dataField: 'houseMasterID',
    displayName: 'House Master ID',
    dataType: 'number',
  },
]

export const JOB_FILTER_FIELDS: ChartField[] = JOB_ALL_FIELDS

export const JOB_DATE_FILTER_FIELDS: ChartField[] = JOB_ALL_FIELDS.filter(
  (jf) => jf.dataType === 'date'
)

export const JOB_ARGUMENT_FIELDS: ChartField[] = JOB_ALL_FIELDS.filter(
  (jf) => jf.dataType === 'string' || jf.dataType === 'date' || jf.dataType === 'boolean'
)

export const JOB_VALUE_FIELDS: ChartField[] = [NUM_MATCHED_ITEMS_VALUE_FIELD].concat(
  JOB_ALL_FIELDS.filter((jf) => jf.dataType === 'number' && jf.dataField !== 'houseMasterID')
)

export const JOB_SERIES_GROUP_FIELDS: ChartField[] = JOB_ALL_FIELDS.filter(
  (jf) =>
    jf.dataType === 'string' || jf.dataType === 'boolean'
)
